import { create } from "zustand";

export interface VerificationChallenge {
	nonce: string;
	expiresAtEpochSeconds: number;
	signature: string;
}

export interface Step1CompletedToken {
	expiresAtEpochSeconds: number;
	signature: string;
}

interface RegistrationState {
	step: number;
	form: {
		firstName?: string;
		lastName?: string;
		email: string;
		challenge?: VerificationChallenge;
		codeExpirySeconds?: number;
		step1CompletedToken?: Step1CompletedToken;
		lockoutUntilEpochMs?: number;
	};
	setField: <K extends keyof RegistrationState["form"]>(field: K, value: RegistrationState["form"][K]) => void;
	nextStep: () => void;
	prevStep: () => void;
	setStep: (step: number) => void;
	reset: () => void;
}

const initialState = {
	step: 1,
	form: {
		firstName: undefined,
		lastName: undefined,
		email: "",
		challenge: undefined,
		codeExpirySeconds: undefined,
		step1CompletedToken: undefined,
		lockoutUntilEpochMs: undefined
	}
};

export const useRegistrationStore = create<RegistrationState>((set) => ({
	...initialState,
	setField: (field, value) =>
		set((state) => ({
			form: { ...state.form, [field]: value }
		})),
	nextStep: () =>
		set((state) => ({
			step: state.step + 1
		})),
	prevStep: () =>
		set((state) => ({
			step: Math.max(1, state.step - 1)
		})),
	setStep: (step: number) => set(() => ({ step })),
	reset: () => set(() => ({ ...initialState, form: { ...initialState.form } }))
}));
